// Google Analytics 4 — tagueamento de uso do sistema.
//
// Como funciona por ambiente: o ID vem de VITE_GA_ID (build-time). Sem ID
// (dev/hml por padrão) nada é carregado e os eventos caem em console.debug —
// zero custo e zero rede. Em produção, defina VITE_GA_ID=G-XXXXXXX no build
// (ver deploy/.env.production.example e docs/INTEGRACOES.md).
//
// Convenção de eventos: trackEvent(acao, categoria, rotulo, valor)
//   acao      = o que o usuário fez ('click_action', 'export_csv', 'aprovar')
//   categoria = tela/módulo ('cadastro', 'financeiro', 'aprovacoes')
//   rotulo    = detalhe ('notas', 'baixar', id do item)
import { readCookieConsent } from './consent.js';

const GA_ID = import.meta.env.VITE_GA_ID || '';

let initialized = false;

export function initGA() {
  if (initialized || !GA_ID || typeof window === 'undefined' || readCookieConsent() !== 'accepted') return;
  initialized = true;

  const s = window.document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  window.document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // page_view manual: SPA — enviamos a cada troca de rota (trackPageView).
  window.gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageView(path, title) {
  if (typeof window === 'undefined' || readCookieConsent() !== 'accepted') return;
  if (window.gtag && GA_ID) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title || window.document.title,
    });
  } else if (window.console) {
    window.console.debug(`[GA page_view] ${path}`);
  }
}

export function trackEvent(action, category, label, value) {
  if (typeof window === 'undefined' || readCookieConsent() !== 'accepted') return;
  if (window.gtag && GA_ID) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  } else if (window.console) {
    window.console.debug(`[GA event] ${action} · ${category} · ${label}${value !== undefined ? ` · ${value}` : ''}`);
  }
}
